import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\"><a href=\"#container\"></a> Container </h1><div class=\"py-5\"> Container components for scaffolding basic structure of the page:<br><br><code>&lt;el-container&gt;</code>: wrapper container. When nested with a <code>&lt;el-header&gt;</code> or <code>&lt;el-footer&gt;</code>, all its child elements will be vertically arranged. Otherwise horizontally.<br><br><code>&lt;el-header&gt;</code>: container for headers.<br><br><code>&lt;el-aside&gt;</code>: container for side sections (usually a side nav).<br><br><code>&lt;el-main&gt;</code>: container for main sections.<br><br><code>&lt;el-footer&gt;</code>: container for footers. </div>", 2)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "d-flex align-items-center rounded py-5 px-5 bg-light-info" }
const _hoisted_6 = { class: "svg-icon svg-icon-3x svg-icon-info me-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-gray-600 fw-bold fs-5" }, [
  /*#__PURE__*/_createTextVNode(" These components use flex for layout, so please make sure your browser supports it. Besides, "),
  /*#__PURE__*/_createVNode("code", null, "<el-container>"),
  /*#__PURE__*/_createTextVNode("'s direct child elements have to be one or more of the latter four components. And father element of the latter four components must be a "),
  /*#__PURE__*/_createVNode("code", null, "<el-container>"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_EIUCommonLayouts = _resolveComponent("EIUCommonLayouts")
  const _component_EIUExample = _resolveComponent("EIUExample")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
          ]),
          _hoisted_7
        ])
      ])
    ]),
    _createVNode(_component_EIUCommonLayouts),
    _createVNode(_component_EIUExample)
  ], 64))
}